module.exports = __webpack_public_path__ + "img/pay-staff-list.96a8c47c.svg";